import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Button, styled } from '@mui/material'
import { format } from 'date-fns'
import SnackBarUtils from '../../../../utils/SnackBarUtils'
import '../../../../styles/sortableData.scss'
import { MedioPago } from '../../../../dto/ContractDTO'
import ConfirmDialog from '../../../../pages/Products/components/ConfirmDialog'
import EditarMovimiento from './editarMovimiento'
import { deleteCtaCte } from '../../services/cta.cte.services'
import { PropsCtaCte } from '.'

const ContentTable = styled('div')({
  width: '97%'
})

// const Line = styled.div`
//   width: 97%;
//   border: 1px solid;
//   display: flex;
//   gap: 6px;
//   margin-top: 8px;
//   border-radius: 5px;
// `;

// const Celda = styled.div`
//   /* width: 97%; */
//   /* border: 1px solid; */
// `;

// interface UpIconParams {
//   className?: string;
//   color?: string;
// }

export interface PropsListCtaCte {
  show?: boolean
  headers?: string[]
  handleClose?: any
  result: any[]
  setEdit: (e: boolean) => void
  setEditMovimiento: (m: any) => void
  onDelete: (idProductoContrato: number, idLocal: number) => Promise<void>
  closeRenovations: () => void
}

const TableCtaCte: React.FC<PropsListCtaCte> = (props: PropsListCtaCte) => {
  // const executeAction = (url: string) => {
  //   const idContrato = url
  //     .substring(url.indexOf("contratos"), url.length)
  //     .split("/")[1];
  //   axiosInstanceMain
  //     .get(url)
  //     .then((result) => {
  //       window.alert(result.data);
  //       if (result.status === 200) {
  //         props.setNoShowContracts([
  //           ...props.noShowContracts,
  //           Number.parseInt(idContrato),
  //         ]);
  //       }
  //       closeRenovations();
  //     })
  //     .catch(error => {
  //       console.log(error);
  //     });
  // };

  return (
    <section className="modal-main" style={{ marginTop: '40px', height: '700px', overflow: 'auto' }}>
      <header className="contract-actions-header">
        <h3 className="contract-actions-title">
          {/* {(props.contract?.cantidad > 1
              ? props.contract?.productoNombre + "x" + props.contract?.cantidad
              : props.contract?.productoNombre) +
              ` Local ID ${props.contract?.idContratoClienteLocal}`} */}
          {'Cuenta Corriente'}
        </h3>
        <button className="modal-close" onClick={props?.closeRenovations} aria-label="Cerrar">
          <CloseIcon />
        </button>
      </header>
      <div>
        {/* {isMobile ? (
            <div className="btn-toolbar" role="toolbar">
              {result.map((a: any) => {
                return (
                  <Line>
                    {props.headers.map((h: any, index: number) => {
                      return (
                        <Celda>
                          <p>
                            {h}: {a[props.attributesToShow[index]]}
                          </p>
                        </Celda>
                      );
                    })}
                  </Line>
                );
              })}
            </div>
          ) : ( */}
        <ContentTable>
          <table className="table table-striped table-bordered premise-table">
            <thead className="table-active">
              <tr>
                {props.headers &&
                  props.headers.map((h: any, index) => {
                    return (
                      <th key={index}>
                        <button
                          type="button"
                          // onClick={() => requestSort("idContrato")}
                          // className={getClassNamesFor("idContrato")}
                        >
                          {h}
                        </button>
                      </th>
                    )
                  })}
              </tr>
            </thead>
            <tbody>
              {props.result.map((item: any, index) => {
                const fecha = new Date(item.fechaFormateada)
                const formatDate = format(fecha, 'dd/MM/yyyy HH:mm:ss')
                return (
                  <tr key={item.idContratoCuentaCorriente}>
                    <th>{item.idContrato}</th>
                    <th>{item.idContratoCuentaCorriente}</th>
                    <th>{formatDate}</th>
                    <th>{item.productoNombre}</th>
                    <th>{item.movimientoTipo + ' ' + item.movimiento}</th>
                    <th>{item.medioDePago}</th>
                    <th>{item.comisionMedioDePago}</th>
                    <th>{item.observaciones != null ? item.observaciones : '-'}</th>
                    <th style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() => {
                          props.setEditMovimiento(item)
                          props.setEdit(true)
                        }}
                      >
                        Editar
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          props?.onDelete(item.idContratoCuentaCorriente, item.idClienteLocal)
                        }}
                      >
                        Borrar
                      </Button>
                    </th>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </ContentTable>
        {/* )} */}
      </div>
    </section>
  )
}

export default TableCtaCte
